module.exports = __webpack_public_path__ + "static/media/profile-press-awi.e8fb4534.png";